import MiniProgramPage from 'D:/小小程序员/项目/medical-management/OPO-uni/pages/my/health-records.vue'
wx.createPage(MiniProgramPage)